export default __webpack_public_path__ + "static/greenEconomy-03a01f37c4cde435cb353796c31da3fe.jpg";